export const HIGHLIGHTED_TECH_SPECS = {
  // MacBook
  110: [
    ['color'],
    ['date_release'],
    ['processor', 'processor_speed'],
    ['graphic_card'],
    ['last_os_compatibility'],
    ['usbc_port'],
  ],
  // MacBook M1
  528: [
    ['color'],
    ['macbook_m1_processor'],
    ['macbook_m1_graphic_card'],
    ['touch_id'],
    ['touch_bar'],
    ['year_date_release'],
  ],
  // Office laptop
  9: [
    ['color'],
    ['processor', 'processor_speed'],
    ['graphic_card'],
    ['touchscreen'],
    ['os'],
    ['year_date_release'],
  ],
  // Apple watch
  170: [['year_date_release'], ['storage'], ['4G'], ['bluetooth']],
}

export const CATEGORIES_WITH_HIGHLIGHTED_TECH_SPECS = [110, 528, 9, 170]
